import { soundsGeneric } from '../engine/soundsGeneric-sidecar'
import { pubSub } from '../engine/pubSub-sidecar'
import { log } from '../engine/log-sidecar'
import { l } from '../lib/imports'
let doPlayLoaded = false
let soundTest = false

let _musicPath = ''
const logNamespace = 'sounds'
export function load(audioJson: any, musicPath: string) {
  _musicPath = musicPath + '/'
  soundsGeneric.load(audioJson, () => {
    log.x(logNamespace, 'loaded')
    if (doPlayLoaded) {
      playLoaded()
    }
    if (soundTest) {
      setInterval(() => {
        playLoaded()
      }, 500)
    }
  })
  playMusicMenu()
}

// -- current below

export function playSelectMonster() {
  //soundsGeneric.playWithRandomRate('select_a')
  soundsGeneric.play('select_a')
}
export function playSpawnMonster(name: string) {
  //soundsGeneric.playWithRandomRate('select_a')

  console.log('spawning monster', name)

  if (name === 'Slime') {
    soundsGeneric.play('jelly')
  } else if (name === 'Snake') {
    soundsGeneric.play('snake')
  } else {
    soundsGeneric.play('special_a')
  }
}
// -- old below

// TODO: replace all of these

export function playMusic1() {
  // need new!
  // soundsGeneric.playMusic(_musicPath + 'loop')
}
export function playMusicMenu() {
  // need new!
  // soundsGeneric.playMusic(_musicPath + 'loop2')
}

export function playLoaded() {
  // need new!
  // soundsGeneric.play('pickup001')
  soundsGeneric.play('smash001')
}

export function playCollisionMonsterBoundary() {
  soundsGeneric.playWithRandomRate('smash001')
}
export function playCollisionMonsterPillar() {
  soundsGeneric.playWithRandomRate('smash001')
}
export function playMonsterHurt() {
  soundsGeneric.playWithRandomRate('hurt001')
}

export function playPartDestroyed() {
  // need new!
  soundsGeneric.playWithRandomRate('smash001')
}

export function playPartConnected() {
  // need new!
  soundsGeneric.playWithRandomRate('hurt001')
}

export function playClick() {
  // need new!
  soundsGeneric.playWithRandomRate('hurt001')
}

export function play(soundName: string) {
  soundsGeneric.play(soundName)
}

// Links to other systems
pubSub.on('gui:click-button', () => {
  playClick()
})
